// Fixed table row and header heights, shared by DataTable (virtualizer size
// estimates, row classes), BaseTable, ui/table and TableSkeleton so a loading
// table is the same shape as the loaded one (design audit S12) and every
// table shares one header and one row height (design audit S10).
//
// There is deliberately one row height. Session K defined a second,
// comfortable 52 px density for module lists; the compact-rows pass took every
// table to 40 px and nothing asked for the taller row again, so it is gone
// rather than left as a token the app never reaches for.

export const DEFAULT_ROW_HEIGHT = 40
// 44 px: one step above the 40 px row so a section reads as a heading without
// the old 52 px slab Joel flagged as too tall (2026-09-10).
export const GROUP_HEADER_ROW_HEIGHT = 44
export const TABLE_HEADER_HEIGHT = 36

export const TABLE_ROW_HEIGHT_CLASS = 'h-10'
export const GROUP_HEADER_ROW_HEIGHT_CLASS = 'h-11'
export const TABLE_HEADER_HEIGHT_CLASS = 'h-9'

/** One header token: 11 px, 600, uppercase, muted. Mirrored by `.data-table th` in table-styles.css. */
export const TABLE_HEADER_TEXT_CLASS =
  'text-[11px] font-semibold uppercase tracking-[0.04em] text-muted-foreground'
